import { Box } from '@mui/material';

import type { ReactNode } from 'react';

interface ReportDrillInLayoutProps {
    children: ReactNode;
}

export const ReportDrillInMetrics = ({
    children,
}: ReportDrillInLayoutProps) => (
    <Box
        sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '16px',
            marginBottom: '32px',
            '& > *:only-child': {
                maxWidth: 'calc((100% - 32px) / 3)',
            },
        }}
    >
        {children}
    </Box>
);

export const ReportDrillInSections = ({
    children,
}: ReportDrillInLayoutProps) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '32px',
        }}
    >
        {children}
    </Box>
);
